import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=843571fa&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('843571fa')) {
      api.createRecord('843571fa', component.options)
    } else {
      api.reload('843571fa', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=843571fa&", function () {
      api.rerender('843571fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-45L4qOw433b4x/JS/childrenage.vue"
export default component.exports